import { Collapse as InnerCollapse, CollapsePanel } from './collapse';
const Collapse = InnerCollapse;
Collapse.Panel = CollapsePanel;
export default Collapse;
